__webpack_require__.rv = function() { return "1.5.2"; }